import {
    useEditController,
    EditContextProvider,
    Form,
    SaveButton,
    useNotify,
    useRedirect,
    useTranslate,
    useRefresh,
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton,
} from '@mui/material';

import { useFormContext } from 'react-hook-form';
import { Resources } from '../../resource';
import ColorForm from './ColorForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditColor = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const form = useFormContext();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.color,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.color.updateSuccess'), { type: 'success' })
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    default:
                        notify(t('module.color.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });

    if (controller.isLoading || !controller.record) return null;

    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.color.edit')}</DialogTitle>
                <DialogContent>
                    <ColorForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="colors" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditColor;
